import React, { useState } from 'react';
import { Link } from 'react-router';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import contentSkillsLogo from './content-skills-logo.png';
import VideoHelpModal from './VideoHelpModal';
import './styles.scss';

const CSPBanner = ({ subject, path }) => {
  const cspLink = `/${subject}/reports/csperformance`;
  const CSP_READ_MORE_LINK =
    'https://apclassroom.clickhelp.co/articles/#!ap-classroom-user-guide-for-students/stu-reports-csperformance';
  const cspTitle = 'Content & Skills Performance Report';
  const isCSP = path === 'csp-report';
  const [displayCSPBanner, setDisplayCSPBanner] = useState(
    !localStorage.getItem(`dismissed-csp-banner-${path}`),
  );
  const [showPromoVideo, setShowPromoVideo] = useState(false);
  const closeCSPBanner = () => {
    localStorage.setItem(`dismissed-csp-banner-${path}`, true);
    setDisplayCSPBanner(false);
  };
  if (!displayCSPBanner) return null;
  return (
    <React.Fragment>
      <div className="flex p-6 bg-[#E4FFD499] banner-wrapper">
        <div className="pt-6 pr-6">
          <img src={contentSkillsLogo} alt="Content & Skills Performance" />
        </div>
        <div className="csp-banner__text">
          <h3 className="inline">Content & Skills Performance Report </h3>
          <p className="leading-[2rem]">
            See your strengths and opportunities across content and skills with
            our {isCSP ? cspTitle : <Link to={cspLink}>{cspTitle}</Link>}.
            <Link to="" onClick={() => setShowPromoVideo(true)}>
              &nbsp;Watch a video
            </Link>{' '}
            or{' '}
            <a href={CSP_READ_MORE_LINK} target="_blank" rel="noreferrer">
              read all about it
            </a>{' '}
            to learn more.
          </p>
        </div>
        <div className="ml-auto">
          <ButtonWithIcon
            data-test-id="modal-close-button"
            isIcon
            isNaked
            size="tiny"
            tabIndex={0}
            icon="close"
            onClick={closeCSPBanner}
            aria-label="Close"
          />
        </div>
      </div>
      {!!showPromoVideo && (
        <VideoHelpModal
          show={showPromoVideo}
          onClose={() => setShowPromoVideo(false)}
        />
      )}
    </React.Fragment>
  );
};

export default CSPBanner;
